module.exports = __webpack_public_path__ + "qi.svg?6e4ccf4ad595eb2000abd03418481b36";


//////////////////
// WEBPACK FOOTER
// ./assets/images/qi.svg
// module id = 325
// module chunks = 0